import { filter } from 'rxjs/operators/filter';
import { Store } from 'vuex';
import { RootStoreState } from '../../store';

export function noResultsStoredOrExpected(store: Store<RootStoreState>) {
  return filter(() => !store.state.search.results.length && !store.state.search.loading);
}
